module.exports = __webpack_public_path__ + "static/img/product-swipe24.89b4e485.png";